import { useEffect, type ReactNode } from "react";
import { platform } from "../platform/index.js";
import { useToast } from "./Toast.js";
import { destinationOf, type Destination, type DestinationShell } from "./destination.js";

/**
 * **الرابطُ الذي فُتح عليه التطبيق — قارئُه الوحيد.**
 *
 * الإشعارُ المدفوع على الهاتف، وتطبيقُ أندرويد، يفتحان `/plan-items/<id>` و`/cards/<id>`.
 * **ولم يكن أحدٌ يقرأ العنوان**: فكان كلُّ إشعارٍ يُنقَر يفتح الرئيسية، لا الشغلَ الذي جاء
 * من أجله. وجده تجريبُ كل موظف، ولم يره اختبارٌ لأن الوجهاتِ كلَّها مقروءةٌ من داخل التطبيق.
 *
 * ويُركَّب داخل القوقعة، أي بعد الجلسة: فمن فتح الرابط وهو خارج يدخل أولاً ثم يصل إليه.
 */
export function OpeningLink({
  shell,
  onOpen,
}: {
  readonly shell: DestinationShell;
  readonly onOpen: (destination: Destination) => void;
}): ReactNode {
  const toast = useToast();
  useEffect(() => {
    const path = platform.pathname;
    if (path === "/") return;
    platform.dropPath();
    const destination = destinationOf(path);
    if (destination === null) return;
    /** **والبورتالُ يقرر رفضَ الرابط الداخليّ بنفسه**؛ وموظفٌ برابط عميل لا يجد ما يُفتح */
    if (shell === "staff" && destination.shell !== "staff") {
      toast.failed({ code: "NOT_FOUND", messageKey: "errors.notFound", correlationId: "" });
      return;
    }
    onOpen(destination);
    // يُقرأ مرةً عند التركيب: فالرابطُ حدثُ الفتح، لا حالةٌ تُتابَع.
  }, []);
  return null;
}
